import { defineComponent, ref } from 'vue';
import Banner from '@/components/Banner2';
import Title from '@/components/Title/index.vue';
import BusiCard from '@/components/BusiCard/index.vue';
import SpeechCase from '@/components/SpeechCase';
import Translate from './components/translate.vue';
import Advantages2 from '@/components/Advantages2';
import Appointment2 from '@/components/Appointment2/index.vue';
export default defineComponent({
  components: {
    Banner,
    Title,
    BusiCard,
    SpeechCase,
    Translate,
    Advantages2,
    Appointment2
  },
  setup() {
    const imageUrl = require('@/assets/images/TextTranslation-banner.png');
    const bannerTitle = ref('文本翻译');
    const bannerText = ref('采用世界领先的神经机器翻译模型，实现中文、英文、西法德语等高质量互译，支持定制化语料库训练。');
    const adsListLeft = [{
      title: '翻译质量领先',
      desc: '第十六届全国机器翻译大会(CCMT 2020)，获得英中翻译第三名，提供业界领先的机器翻译服务'
    }, {
      title: '海量训练语料',
      desc: '拥有海量平行语料数据，利用先进的深度学习建模技术，翻译结果更加准确'
    }];
    const adsListRight = [{
      title: '简单易用',
      desc: '提供通用API接口及Demo文件，接入方式方便快捷'
    }, {
      title: '个性化服务',
      desc: '提供个性化解决方案，可针对不同需求定制化服务方案'
    }];
    const funcList = [{
      title: '金融资讯',
      desc: '提供高准确率的金融领域翻译，原汁原味获取全球金融商业资讯',
      img: require('@/assets/images/translation-app-1.png')
    }, {
      title: '舆情监控',
      desc: '即时准确地翻译结果大量金融专业名词是同花顺的优势，轻松掌握中国企业舆情',
      img: require('@/assets/images/translation-app-2.png')
    }, {
      title: '业务出海',
      desc: '快速准确地把网站、APP上的中文内容翻译成英文，助力业务平稳出海',
      img: require('@/assets/images/translation-app-3.png')
    }, {
      title: '书籍翻译',
      desc: '稳定高效的翻译服务可支持长篇学术文章、金融书籍等翻译',
      img: require('@/assets/images/translation-app-4.png')
    }];
    const casesList = [{
      title: '同花顺',
      img_head: require('@/assets/images/translation-case-1.png'),
      img_icon: require('@/assets/images/translation-case-5.png')
    }, {
      title: 'i问财',
      img_head: require('@/assets/images/translation-case-2.png'),
      img_icon: require('@/assets/images/translation-case-5.png')
    }, {
      title: 'ifind',
      img_head: require('@/assets/images/translation-case-3.png'),
      img_icon: require('@/assets/images/translation-case-5.png')
    }, {
      title: '舆情终端',
      img_head: require('@/assets/images/translation-case-4.png'),
      img_icon: require('@/assets/images/translation-case-5.png')
    }];
    return {
      imageUrl,
      bannerTitle,
      bannerText,
      adsListLeft,
      adsListRight,
      funcList,
      casesList
    };
  }
});